import uamAsyncRequestService from '../uam/uamAsyncRequestService';
import uamfAsyncRequestService from '../uamf/uamfAsyncRequestService';
import damDeviceHelpers from './damDeviceHelpers';

const getService = (dusn) => (damDeviceHelpers.isUamf(dusn) ? uamfAsyncRequestService : uamAsyncRequestService);

const waitAsyncRequestComplete = (dusn, requestId, timeout, statusCheckTimeout) =>
    getService(dusn).waitAsyncRequestComplete(dusn, requestId, timeout, statusCheckTimeout);

export default {
    waitAsyncRequestComplete,
};
